export default __webpack_public_path__ + "static/media/theme_vikinger.18454b59.jpg";